/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/CreateProcedureReceivables/Task/Content/Basket/Empty"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtTysiainputlabelColorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputLabel.color.primary.base'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Empty.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-4PwO0': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Task Basket"
 color={dtTysiainputlabelColorPrimaryBase}
 size="normal"
 weight="semibold"
 whiteSpace="nowrap"
 overflowX="hidden"
 textOverflow="ellipsis"
 marginBottom={dtSpaceXs}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Task baskets not found"
/>
</div>
{children}
</React.Fragment>)
}